import constants from 'constants';

const {
  ADD_CLIENT_URLS_ADMIN,
  ADD_CLIENT_URLS,
  ADD_CLIENT_URL_ADMIN,
  ADD_CLIENT_URL_WEBINARS_ADMIN,
  SET_TEMP_CLIENT_URL,
  ADD_CLIENT_WEBINARS,
} = constants;

const clientUrls = (clientUrls = {
    list: {
      values: [],
      isLoaded: false,
      upcoming: {
        values: [],
        page: 1,
        pages: 0,
        count: 0,
      },
      current: {
        values: [],
        page: 1,
        pages: 0,
        count: 0,
      },
      previous: {
        values: [],
        page: 1,
        pages: 0,
        count: 0,
      },
    },
    admin: {
      webinars: [],
      clientUrl: null,
      temp: {},
      list: {
        values: [],
        page: 1,
        pages: 0,
        total_pages: 0,
        query: {
          title: '',
          order: 'name',
          direction: 'desc',
        },
      },
    },
  }, {
    type,
    payload
  }) => {
  switch(type) {
    case ADD_CLIENT_URLS:
      return {
        ...clientUrls,
        ...{
          list: {
            ...clientUrls.list,
            values: payload.values,
            isLoaded: true,
          },
        },
      };
    case ADD_CLIENT_URLS_ADMIN:
      return {
        ...clientUrls,
        ...{
          admin: {
            ...clientUrls.admin,
            list: {
              values: payload.values,
              page: payload.page,
              total_pages: payload.total_pages,
              count: payload.count,
            },
          },
        },
      };
    case ADD_CLIENT_URL_ADMIN:
      return {
        ...clientUrls,
        ...{
          admin: {
            ...clientUrls.admin,
            clientUrl: payload.clientUrl,
          },
        },
      };
    case ADD_CLIENT_URL_WEBINARS_ADMIN:
      return {
        ...clientUrls,
        ...{
          admin: {
            ...clientUrls.admin,
            webinars: payload.webinars,
          },
        },
      };
    case SET_TEMP_CLIENT_URL:
      return {
        ...clientUrls,
        ...{
          admin: {
            ...clientUrls.admin,
            temp: payload.temp,
          },
        }
      };
    case ADD_CLIENT_WEBINARS:
      return {
        ...clientUrls,
        ...{
          list: {
            ...clientUrls.list,
            [payload.type]: {
              values: payload.webinars,
              count: payload.count,
              pages: payload.pages,
            },
          },
        }
      };
    default: return clientUrls;
  };
};

export { clientUrls };



// WEBPACK FOOTER //
// ./src/reducers/clientUrls.js